import Image from 'next/image';

/**
 * Wantek mark — the `.W` brand sigil. Sourced from public/logos/WVert.webp,
 * which already carries the cyan/blue gradient, so the `text-` class from
 * Header is purely a sizing override — colour comes from the asset.
 */
export function WantekMark({ className = '' }: { className?: string }) {
  return (
    <Image
      src="/logos/WVert.webp"
      alt=""
      aria-hidden
      width={80}
      height={56}
      priority
      className={className}
    />
  );
}
